var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "border-r py-2 cursor-pointer wrap-text",
      style: `width: 15rem; height: 80px; border-left: 6px solid  ${
        !_vm.isInner ? _vm.item.color : "transparent"
      }`,
      on: {
        click: function ($event) {
          return _vm.toggleCollapse()
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "flex relative flex-row items-center content-center h-full leading-tight",
        },
        [
          !_vm.isInner
            ? _c("span", [
                !_vm.isOpened
                  ? _c(
                      "svg",
                      {
                        staticClass: "ml-2",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "13",
                          height: "8",
                          viewBox: "0 0 13 8",
                          fill: "none",
                          if: "isOpened",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M0.516455 2.97877L5.02816 7.49047C5.70753 8.16984 6.80497 8.16984 7.48434 7.49047L11.996 2.97877C13.0935 1.88133 12.3096 0 10.7592 0H1.73583C0.18548 0 -0.580987 1.88133 0.516455 2.97877Z",
                            fill: "#CACACA",
                          },
                        }),
                      ]
                    )
                  : _c(
                      "svg",
                      {
                        staticClass: "ml-2",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "13",
                          height: "8",
                          viewBox: "0 0 13 8",
                          fill: "none",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M11.9914 5.02123L7.47965 0.509527C6.80028 -0.169841 5.70284 -0.169841 5.02347 0.509527L0.511771 5.02123C-0.58567 6.11867 0.198217 8 1.74857 8L10.772 8C12.3223 8 13.0888 6.11867 11.9914 5.02123Z",
                            fill: "#CACACA",
                          },
                        }),
                      ]
                    ),
              ])
            : _c("span", { staticClass: "ml-3" }),
          _c(
            "div",
            {
              staticClass: "ml-3 flex cursor-pointer",
              attrs: { id: "avatar-container", name: _vm.item.id },
              on: {
                mouseover: ($event) => _vm.showProjectDetailsModalOn(),
                mouseleave: ($event) => _vm.showProjectDetailsModalOff(),
                click: ($event) => _vm.showProjectDetailsModalOff(),
              },
            },
            [
              _c("CircleWithInitials", {
                staticClass: "mr-2",
                attrs: { title: _vm.item.name, id: _vm.item.id },
              }),
            ],
            1
          ),
          _c("span", { staticClass: "ml-5 leading-tight" }, [
            _vm._v(_vm._s(_vm.item.name)),
          ]),
          _c(
            "span",
            { staticClass: "flex absolute top-0 right-2" },
            [
              !_vm.item.manager_id
                ? _c(
                    "Tooltip",
                    {
                      attrs: {
                        title: _vm.missingManager,
                        variant: _vm.TooltipVariants.DARK,
                        placement: "top",
                      },
                    },
                    [
                      _c("span", [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "20",
                              height: "20",
                              viewBox: "0 0 20 20",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("rect", {
                              attrs: {
                                width: "20",
                                height: "20",
                                rx: "5",
                                fill: "#DA1B8F",
                              },
                            }),
                            _c("path", {
                              attrs: {
                                d: "M10 10C11.2625 10 12.2857 8.88086 12.2857 7.5C12.2857 6.11914 11.2625 5 10 5C8.7375 5 7.71429 6.11914 7.71429 7.5C7.71429 8.88086 8.7375 10 10 10ZM11.7107 10.6367L10.8571 14.375L10.2857 11.7188L10.8571 10.625H9.14286L9.71429 11.7188L9.14286 14.375L8.28929 10.6367C7.01607 10.7031 6 11.8418 6 13.25V14.0625C6 14.5801 6.38393 15 6.85714 15H13.1429C13.6161 15 14 14.5801 14 14.0625V13.25C14 11.8418 12.9839 10.7031 11.7107 10.6367Z",
                                fill: "white",
                              },
                            }),
                          ]
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
              !_vm.item.manager_id &&
              Object.keys(_vm.item.project_activities).length === 0
                ? _c("span", { staticClass: "mx-0.5" })
                : _vm._e(),
              Object.keys(_vm.item.project_activities).length === 0
                ? _c(
                    "Tooltip",
                    {
                      attrs: {
                        title: _vm.missingContractor,
                        variant: _vm.TooltipVariants.DARK,
                        placement: "top",
                      },
                    },
                    [
                      _c("span", [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "20",
                              height: "20",
                              viewBox: "0 0 20 20",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("rect", {
                              attrs: {
                                width: "20",
                                height: "20",
                                rx: "5",
                                fill: "#FF8E3C",
                              },
                            }),
                            _c("path", {
                              attrs: {
                                d: "M10.6667 10.5C11.7664 10.5 12.7381 9.50134 12.8333 8.27369C12.8806 7.65695 12.68 7.0818 12.2683 6.6545C11.861 6.23243 11.2917 6 10.6667 6C10.0367 6 9.46687 6.23103 9.06249 6.65049C8.65354 7.07457 8.45416 7.65093 8.49999 8.27329C8.59354 9.50114 9.56499 10.5 10.6667 10.5ZM14.9871 14.1916C14.8112 13.251 14.2623 12.4609 13.3998 11.9064C12.6337 11.414 11.6631 11.1428 10.6667 11.1428C9.6702 11.1428 8.69958 11.414 7.93354 11.9062C7.07104 12.4607 6.52208 13.2508 6.34625 14.1913C6.30604 14.4069 6.36062 14.6201 6.49604 14.7761C6.55746 14.8473 6.63458 14.9043 6.72177 14.943C6.80896 14.9817 6.90402 15.0012 7 14.9999H14.3333C14.4294 15.0013 14.5245 14.9819 14.6117 14.9432C14.699 14.9045 14.7762 14.8475 14.8377 14.7763C14.9727 14.6203 15.0273 14.4071 14.9871 14.1916ZM6.83333 11.1428V10.3393H7.66666C7.75507 10.3393 7.83985 10.3054 7.90236 10.2451C7.96488 10.1848 8 10.1031 8 10.0178C8 9.93258 7.96488 9.85083 7.90236 9.79055C7.83985 9.73027 7.75507 9.6964 7.66666 9.6964H6.83333V8.89284C6.83333 8.80759 6.79821 8.72583 6.7357 8.66555C6.67319 8.60528 6.5884 8.57141 6.5 8.57141C6.41159 8.57141 6.32681 8.60528 6.2643 8.66555C6.20178 8.72583 6.16666 8.80759 6.16666 8.89284V9.6964H5.33333C5.24493 9.6964 5.16014 9.73027 5.09763 9.79055C5.03512 9.85083 5 9.93258 5 10.0178C5 10.1031 5.03512 10.1848 5.09763 10.2451C5.16014 10.3054 5.24493 10.3393 5.33333 10.3393H6.16666V11.1428C6.16666 11.2281 6.20178 11.3098 6.2643 11.3701C6.32681 11.4304 6.41159 11.4642 6.5 11.4642C6.5884 11.4642 6.67319 11.4304 6.7357 11.3701C6.79821 11.3098 6.83333 11.2281 6.83333 11.1428Z",
                                fill: "white",
                              },
                            }),
                          ]
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }